import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../ui/button';
import { Input } from '../../../ui/input';
import { TableCell, TableRow } from '../../../ui/table';

export type NewLineItemRowProps = {
	onSave: (data: { description: string; id: string }) => void;
	onRemove: (id: string) => void;
	level?: number;
	lineItem: {
		id?: string | null;
		parentItemId?: string | null;
		description?: string | null;
	};
};

export function NewLineItemRow({ onSave, lineItem, onRemove, level = 0 }: NewLineItemRowProps) {
	const { t } = useTranslation();
	const [description, setDescription] = useState(lineItem.description || '');

	const onSubmit = () => {
		onSave({
			id: lineItem.id as string,
			description,
		});
	};

	const onCancel = () => {
		onRemove(lineItem.id as string);
	};

	return (
		<TableRow className="bg-blue-50 dark:bg-accent">
			<TableCell className="text-muted-foreground">
				<div className="flex items-center gap-1" style={{ paddingLeft: `${level * 16}px` }}>
					<div className="w-4"></div>
					<span>...</span>
				</div>
			</TableCell>
			<TableCell colSpan={5}>
				<Input
					type="text"
					className="bg-input"
					placeholder={t('finance.items.enterDescription')}
					required
					value={description}
					onChange={(e) => setDescription(e.target.value)}
					onKeyDown={(e) => {
						if (e.key === 'Enter' && description.trim()) {
							onSubmit();
						} else if (e.key === 'Escape') {
							onCancel();
						}
					}}
				/>
			</TableCell>
			<TableCell className="p-4 align-middle [&:has([role=checkbox])]:pr-0">
				<div className="flex items-center gap-1">
					<Button onClick={onSubmit} disabled={!description.trim()}>
						{t('common.actions.save')}
					</Button>
					<Button variant="outline" onClick={onCancel}>
						{t('common.actions.cancel')}
					</Button>
				</div>
			</TableCell>
		</TableRow>
	);
}
